module.exports = __webpack_public_path__ + "media/styles/images/svg/pen-gray-dark-36cf3a6bbf9a1489a3e66ba3f5c2be28.svg";